import { Component, Input } from '@angular/core';
import { SortDescriptor } from '@progress/kendo-data-query';
import { keyDescOrder } from 'src/app/shared/helpers/helper';
import { SortOrder } from 'src/app/shared/modules/graphql/enums/generic.enums';
import { IApiInvestigationMetricsFilter, IApiInvestigationMetricsFilterType } from 'src/app/shared/modules/graphql/types/types';
import { LoaderService } from 'src/app/shared/modules/loader/loader.service';
import { NotificationsService } from 'src/app/shared/modules/notifications/notifications.service';
import { InvestigationMetricsBillToCompanyDatasource, InvestigationMetricsBilltoCompanyService } from 'src/app/shared/services/reports';

@Component({
  selector: 'app-investigation-matrics-billto-company',
  templateUrl: './investigation-matrics-billto-company.component.html',
  styleUrls: ['./investigation-matrics-billto-company.component.scss']
})
export class InvestigationMatricsBilltoCompanyComponent {

  @Input() tabIndex;

  private _dataSource: InvestigationMetricsBillToCompanyDatasource;
  public set dataSource(val) {
    this._dataSource = val;
  }
  public get dataSource() {
    return this._dataSource;
  }

  public get pageOptions() {
    if (!this.dataSource) return null;
    return this.dataSource.listPage;
  }

  public sort: SortDescriptor[] = [{
    field: 'COMPANY_NAME',
    dir: 'asc'
  }];

  public tableData = [];

  public yearsArray;
  public receivedDateFilter;
  public keyDescOrder = keyDescOrder;


  constructor(
    private loaderService: LoaderService,
    private investigationMetricsBilltoCompanyService: InvestigationMetricsBilltoCompanyService,
    private notifications: NotificationsService
  ) {
    this.dataSource = new InvestigationMetricsBillToCompanyDatasource(
      this.investigationMetricsBilltoCompanyService
    );
    this.loaderService.attachObservable(this.dataSource.loading$);
  }

  public load() {
    this.dataSource.load().then(() => {
      this.dataSource?.contents$.subscribe((res) => {
        this.tableData = res;
        this.tableData = this.tableData?.map((row) => {
          return {
            ...row,
            data: JSON.parse(row?.data)
          }
        })
      });
    });
  }

  public sortChange = (e) => {
    this.sort = e;
    if (e && e?.[0]?.dir) {
      this.dataSource.listPage.orderBy = e?.[0]?.field;
      this.dataSource.listPage.sortOrder =
        e?.[0]?.dir === "asc" ? SortOrder.ASC : SortOrder.DESC;
    } else {
      this.dataSource.listPage.orderBy = "COMPANY_NAME";
      this.dataSource.listPage.sortOrder = SortOrder.ASC;
    }
    this.load();
  };

  public pageChange(event) {
    this.pageOptions?.paginate(event)
  }

  applyFilter(filters: IApiInvestigationMetricsFilter[]) {
    this.dataSource?.lastFilters?.map(filter => this.dataSource.applyFilter(filter?.type, null));
    filters?.map(filter => this.dataSource.applyFilter(filter?.type, filter?.value));
    this.dataSource.pagingReset();
    this.load();
  }

  clearFilter(filters: IApiInvestigationMetricsFilter[]) {
    this.dataSource?.lastFilters?.map(filter => this.dataSource.applyFilter(filter?.type, null));
    this.dataSource.pagingReset();
    this.load();
  }

  public exportXlsx() {
    const filters = this.dataSource?.lastFilters;
    const finalFilters = [...filters, { type: IApiInvestigationMetricsFilterType.ReportExport, value: 'true' }]
    this.investigationMetricsBilltoCompanyService.get(finalFilters).subscribe((res) => {
      this.notifications.kendoConfirm("Your report export has been successfully queued. You will receive a confirmation email when it is ready.", "Report Export", "", "Ok").subscribe();
    }, error => {
      console.log(error);
      this.notifications.alert("Report Export Failed", "An error occurred while exporting the report. Please try again later.");
    });
  }

}
